import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import BillingStatistics from './components/BillingStatistics'
import BillingTransactionsTab from './components/BillingTransactionsTab'
import BillingCreditUsageTab from './components/BillingCreditUsageTab'
import {useDispatch} from 'react-redux'
import {
  filterDataChange,
  getAll,
  getAllPaymentRequest,
  paymentRequestFilterDataChange,
} from './redux/BillingRedux'
import {createDefaultBillingFilter} from './models/BillingFilterModel'
import {createDefaultTransactionRequestFilter} from './models/PaymentRequestFilterModel'

type Props = {
  className: string
}

const BillingsPage: FC<Props> = (props) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState<'transactions' | 'credit'>('transactions')

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'BILLING.PAGE_TITLE'})}</PageTitle>
      <BillingStatistics />

      <div className='card mb-10'>
        {/* Tab Navigation */}
        <div className='card-header border-0 pt-5'>
          <div className='card-title'>
            <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x fs-6'>
              <li className='nav-item'>
                <button
                  className={`nav-link ${activeTab === 'transactions' ? 'active' : ''}`}
                  onClick={() => {
                    setActiveTab('transactions')
                    dispatch(
                      paymentRequestFilterDataChange(createDefaultTransactionRequestFilter())
                    )
                    dispatch(getAllPaymentRequest())
                  }}
                >
                  {intl.formatMessage({id: 'BILLING.TAB.TRANSACTIONS'})}
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link ${activeTab === 'credit' ? 'active' : ''}`}
                  onClick={() => {
                    setActiveTab('credit')

                    dispatch(filterDataChange(createDefaultBillingFilter()))
                    dispatch(getAll(undefined))
                  }}
                >
                  {intl.formatMessage({id: 'BILLING.TAB.CREDIT_USAGE'})}
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Tab Content */}
        <div className='card-body p-10'>
          {activeTab === 'transactions' ? <BillingTransactionsTab /> : <BillingCreditUsageTab />}
        </div>
      </div>
    </>
  )
}

export default BillingsPage
